import React from "react";
import TestMainScore from "./TestMainScore";
import OtherInningsDetails from "./OtherInningsDetails";
import BowlerCard from "./BowlerCard";
import $ from "jquery";
export default class BatsmenScoreCard extends React.Component {
  componentDidMount() {
    let activeInd = this.props.activeInd;

    if (activeInd && !this.props.close) {
      setTimeout(() => {
        $(".div_" + activeInd).css("display", "block");
        $(".image_" + activeInd).addClass("up_tap_arrow");
        $(".image_" + activeInd).removeClass("down_tap_arrow");
      }, 1000);
    }
  }
  // componentWillReceiveProps() {
  //   console.log("sdfjhg");
  //   let activeInd = this.props.activeInd;

  //   if (activeInd) {
  //     setTimeout(() => {
  //       $(".div_" + activeInd).toggle();
  //       $(".image_" + activeInd).addClass("down_tap_arrow");
  //       $(".image_" + activeInd).removeClass("up_tap_arrow");
  //     }, 1000);
  //   }
  // }
  render() {
    console.log(this.props);
    let batsmen = this.props.inningwisedata["batsmen"];
    let extra_runs = this.props.inningwisedata["extra_runs"];
    let scores_full = this.props.inningwisedata["scores_full"];
    let did_not_bat = this.props.inningwisedata["did_not_bat"];
    let fows = this.props.inningwisedata["fows"];
    let bowlers = this.props.inningwisedata["bowlers"];
    // console.log(batsmen);
    return (
      <div className="score_card_innings">
        <div className="batsmen_scorecard_title_text">
          <h4>Batsmen</h4>
          <div className="b_scorecard_count">
            <h4 className="center">R</h4>
            <h4 className="center">B</h4>
            <h4 className="center">4s</h4>
            <h4 className="center">6s</h4>
            <h4 className="center wd25">SR</h4>
          </div>
        </div>
        {batsmen && batsmen.length > 0
          ? batsmen.map((batdetail, index) => {
            return (
              <div className="batsmen_scors_list">
                <div className="batsmen_scorecard_score">
                  <div className="flex_column wd50">
                    <h4
                      className={
                        batdetail.how_out == "Not out"
                          ? batdetail.position == "striker" ? "batsmen_name text_green required" : "batsmen_name text_green "
                          : "batsmen_name"
                      }
                    >
                      {batdetail.name}
                    </h4>
                    <h5 className="batsmen_out_by">{batdetail.how_out}</h5>
                  </div>
                  <div className="b_scorecard_count">
                    <h4 className="batsmen_run ">{batdetail.runs}</h4>
                    <h4 className="batsmen_run cue_regular">
                      {batdetail.balls_faced}
                    </h4>
                    <h4 className="batsmen_run cue_regular">
                      {batdetail.fours}
                    </h4>
                    <h4 className="batsmen_run cue_regular">
                      {batdetail.sixes}
                    </h4>
                    <h4 className="batsmen_run cue_regular wd25">
                      {batdetail.strike_rate}
                    </h4>
                  </div>
                </div>
              </div>
            );
          })
          : ""}

        <div className="extra_runs_wrpp batsmen_name">
          <h6>Extras</h6>
          <h6>
            {extra_runs ? extra_runs.total : ""}
            {" ("}
            {extra_runs
              ? extra_runs.byes > 0
                ? "b " + extra_runs.byes + ", "
                : ""
              : ""}
            {extra_runs
              ? extra_runs.legbyes > 0
                ? "lb " + extra_runs.legbyes
                : ""
              : ""}
            {extra_runs
              ? extra_runs.noballs > 0
                ? ", nb " + extra_runs.noballs
                : ""
              : ""}
            {extra_runs
              ? extra_runs.wides > 0
                ? ", w " + extra_runs.wides
                : ""
              : ""}
            {") "}
          </h6>
        </div>
        <div className="extra_runs_wrpp batsmen_name">
          <h6>TOTAL</h6>
          <h6>
            <span className="white16_black">{scores_full}</span>
          </h6>
        </div>
        <OtherInningsDetails
          index={this.props.index}
          res={this.props.res}
          key={Math.random()}
          did_not_bat={did_not_bat}
          fows={fows}
        />

        <BowlerCard key={Math.random()} bowlers={bowlers} />
      </div>
    );
  }
}
